/* zod, told not to try `Function("")`. Left to itself it tests once whether it may compile its
   parsers, inside a try/catch. Under the app's Content Security Policy it may not, so the test
   always failed and zod always took its other path: nothing to lose. But the attempt is itself
   a violation, and Firefox reports it on the console of every page that parses anything
   (Chromium does not, which is how it went unseen). The plan asks for no violations at all.

   Every schema in the repo imports `z` from here, so the switch is thrown before the first
   schema exists, whatever order the modules load in. */

import { z } from "zod";

z.config({ jitless: true });

export { z };
